export const keyFormatter = (key: string) => key.replace(/ /g, '_').toLowerCase();
